import * as React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "@/components/ui/command";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { IconCheck, IconSelector } from "@tabler/icons-react";

interface ComboDropProps {
    options: any;
    value: string; // Current selected value
    onSelect: (value: string) => void; // Callback when a value is selected
    disabled?: boolean; // Optional flag to disable dropdown
}

export function ComboDrop({
    options,
    value,
    onSelect,
    disabled,
}: ComboDropProps) {
    const [open, setOpen] = React.useState(false);

    const items = options.map((option: any) => ({
        value: option.toLowerCase(),
        label: option,
    }));

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-[200px] justify-between border border-form-primary-color/50 bg-transparent text-form-primary-text-color ring-0 focus-within:ring-0 hover:bg-form-primary-color focus-visible:ring-0"
                    disabled={disabled}
                >
                    {value
                        ? items.find((item: any) => item.value === value)?.label
                        : "Choose one..."}
                    <IconSelector className="text-form-primary-text-color/80" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="z-[9999] w-[200px] border border-form-primary-color p-0">
                <Command className="z-[9999] bg-form-background-color">
                    {items.length > 10 && (
                        <CommandInput
                            placeholder="Search..."
                            className={cn("h-9")}
                        />
                    )}
                    <CommandList>
                        <CommandEmpty>Not found</CommandEmpty>
                        <CommandGroup>
                            {items.map((item: any) => (
                                <CommandItem
                                    className="text-form-primary-text-color aria-selected:bg-form-primary-color"
                                    key={item.value}
                                    value={item.value}
                                    onSelect={(currentValue) => {
                                        onSelect(
                                            currentValue === value
                                                ? ""
                                                : currentValue
                                        ); // Update value
                                        setOpen(false);
                                    }}
                                >
                                    {item.label}
                                    <IconCheck
                                        className={cn(
                                            "ml-auto",
                                            value === item.value
                                                ? "opacity-100"
                                                : "opacity-0"
                                        )}
                                    />
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
